module.exports = __webpack_public_path__ + "static/media/avatar2023.4093f7a1.svg";